// extracted by mini-css-extract-plugin
export default {"modal":"Xca-z","modalContent":"Yca-z","footer":"Zca-z","cancelBtn":"_ca-z","disabled":"ada-z","formWrapper":"bda-z","fade":"cda-z","fade-in":"dda-z","iframe":"eda-z"};